module.exports = __webpack_public_path__ + "img/case-ai-traffic.00a9df6d.png";